import actionTypes from './actionTypes';

export const fetch = () => ({
  type: actionTypes.FETCH,
});

export const fetched = (data) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const requestAddressUpdate = (waybill, phone) => ({
  type: actionTypes.REQUEST_ADDRESS_UPDATE,
  payload: {
    waybill,
    phone,
  },
});

export const batchSalesOrders = (values) => ({
  type: actionTypes.BATCH_SALES_ORDERS,
  payload: {
    values,
  },
});

export const batchedSalesOrders = (data) => ({
  type: actionTypes.BATCHED_SALES_ORDERS,
  payload: {
    data,
  },
});
export const generateReport = (values) => ({
  type: actionTypes.GENERATE_REPORT,
  payload: {
    values,
  },
});
export const generateOTP = (shipmentId) => ({
  type: actionTypes.GENERATE_OTP,
  payload: {
    shipmentId,
  },
});
export const generatedReport = () => ({
  type: actionTypes.GENERATED_REPORT,
  payload: {},
});

export const toggleBatchingScreen = () => ({
  type: actionTypes.TOGGLE_BATCHING_SCREEN,
  payload: {},
});

export const batchedSuccessfully = () => ({
  type: actionTypes.BATCHED_SUCCESSFULLY,
  payload: {},
});

export const cancelShipments = (data) => ({
  type: actionTypes.CANCEL,
  payload: {
    ...data,
  },
});

export const canceledShipments = () => ({
  type: actionTypes.CANCELLED,
  payload: {},
});
